var _path, _g, _path2, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionTakeMyMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.1464 40.1728C63.1464 53.1487 52.6273 63.6678 39.6513 63.6678C26.6753 63.6678 16.1562 53.1487 16.1562 40.1728C16.1562 27.1968 26.6753 16.6777 39.6513 16.6777C52.6273 16.6777 63.1464 27.1968 63.1464 40.1728Z",
    fill: "url(#paint0_radial_3003_69649)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3003_69649)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.5117,
    cy: 26.7227,
    rx: 10,
    ry: 7.5,
    fill: "white",
    fillOpacity: 0.7
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3003_69649",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 48,
    height: 48
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1464 40.1728C63.1464 53.1487 52.6273 63.6678 39.6513 63.6678C26.6753 63.6678 16.1562 53.1487 16.1562 40.1728C16.1562 27.1968 26.6753 16.6777 39.6513 16.6777C52.6273 16.6777 63.1464 27.1968 63.1464 40.1728Z",
    fill: "url(#paint1_radial_3003_69649)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3003_69649)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3003_69649)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.0117,
    cy: 42.2227,
    rx: 10,
    ry: 7.5,
    transform: "rotate(-90 25.0117 42.2227)",
    fill: "#CEECB5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3003_69649)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.0117,
    cy: 42.2227,
    rx: 10,
    ry: 7.5,
    transform: "rotate(-90 54.0117 42.2227)",
    fill: "#CEECB5"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter3_i_3003_69649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.691 56.2227C45.7369 56.2227 50.783 51.6911 51.9643 48.5057C52.1943 47.8854 51.5966 47.3915 50.9533 47.5456C48.7439 48.0749 44.019 49.0688 39.691 49.0688C35.363 49.0688 30.6381 48.0749 28.4287 47.5456C27.7854 47.3915 27.1877 47.8854 27.4177 48.5057C28.599 51.6911 33.6451 56.2227 39.691 56.2227Z",
    fill: "#262626"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter4_f_3003_69649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.691 56.2227C45.7369 56.2227 50.783 51.6911 51.9643 48.5057C52.1943 47.8854 51.5966 47.3915 50.9533 47.5456C48.7439 48.0749 44.019 49.0688 39.691 49.0688C35.363 49.0688 30.6381 48.0749 28.4287 47.5456C27.7854 47.3915 27.1877 47.8854 27.4177 48.5057C28.599 51.6911 33.6451 56.2227 39.691 56.2227Z",
    fill: "#FBF2C3"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_3003_69649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1262 41.8401C32.4722 41.8316 32.7855 41.7844 33.0661 41.6988C33.356 41.6045 33.6038 41.4803 33.8096 41.3261C34.0153 41.1719 34.1696 40.992 34.2725 40.7864C34.3847 40.5722 34.4408 40.3452 34.4408 40.1053V40.0796C34.4408 39.8654 34.4081 39.6684 34.3426 39.4885C34.2772 39.3086 34.1556 39.1458 33.9779 39.0002C33.8002 38.8545 33.5617 38.726 33.2625 38.6147C32.9632 38.4947 32.5844 38.3876 32.1262 38.2934V41.8401ZM31.509 34.0013C30.8263 34.0185 30.2792 34.1898 29.8677 34.5154C29.4562 34.8323 29.2504 35.2221 29.2504 35.6847V35.7104C29.2504 35.9161 29.2832 36.1088 29.3486 36.2887C29.4141 36.4601 29.531 36.6228 29.6993 36.777C29.8677 36.9227 30.0968 37.0555 30.3867 37.1754C30.6766 37.2953 31.0507 37.4067 31.509 37.5095V34.0013ZM31.4809 42.4055C30.8356 42.3541 30.2464 42.2171 29.7134 41.9943C29.1803 41.763 28.6613 41.4418 28.1562 41.0305L28.6192 40.5294C29.0587 40.9063 29.5076 41.2062 29.9659 41.4289C30.4241 41.6431 30.9385 41.7716 31.509 41.8144V38.1649C30.4522 37.9507 29.69 37.6594 29.2224 37.2911C28.7641 36.9141 28.535 36.4044 28.535 35.7618V35.7361C28.535 35.4192 28.6051 35.1236 28.7454 34.8495C28.8951 34.5668 29.1008 34.3226 29.3627 34.117C29.6245 33.9114 29.9331 33.7486 30.2885 33.6287C30.6532 33.5002 31.0507 33.4316 31.4809 33.4231V32.6777H32.1542V33.4488C32.6967 33.4916 33.1783 33.603 33.5991 33.7829C34.02 33.9542 34.4408 34.1941 34.8617 34.5025L34.3987 35.0037C34.034 34.7038 33.6646 34.4768 33.2905 34.3226C32.9258 34.1684 32.5377 34.0699 32.1262 34.027V37.638C33.1923 37.8436 33.9639 38.1392 34.4408 38.5247C34.9178 38.9016 35.1563 39.4028 35.1563 40.0282V40.0539C35.1563 40.388 35.0814 40.6964 34.9318 40.9791C34.7915 41.2618 34.5858 41.5103 34.3146 41.7245C34.0527 41.9301 33.7347 42.0928 33.3607 42.2128C32.9959 42.3327 32.5938 42.4013 32.1542 42.4184V43.6777H31.4809V42.4055Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.1262 41.8401C32.4722 41.8316 32.7855 41.7844 33.0661 41.6988C33.356 41.6045 33.6038 41.4803 33.8096 41.3261C34.0153 41.1719 34.1696 40.992 34.2725 40.7864C34.3847 40.5722 34.4408 40.3452 34.4408 40.1053V40.0796C34.4408 39.8654 34.4081 39.6684 34.3426 39.4885C34.2772 39.3086 34.1556 39.1458 33.9779 39.0002C33.8002 38.8545 33.5617 38.726 33.2625 38.6147C32.9632 38.4947 32.5844 38.3876 32.1262 38.2934V41.8401ZM31.509 34.0013C30.8263 34.0185 30.2792 34.1898 29.8677 34.5154C29.4562 34.8323 29.2504 35.2221 29.2504 35.6847V35.7104C29.2504 35.9161 29.2832 36.1088 29.3486 36.2887C29.4141 36.4601 29.531 36.6228 29.6993 36.777C29.8677 36.9227 30.0968 37.0555 30.3867 37.1754C30.6766 37.2953 31.0507 37.4067 31.509 37.5095V34.0013ZM31.4809 42.4055C30.8356 42.3541 30.2464 42.2171 29.7134 41.9943C29.1803 41.763 28.6613 41.4418 28.1562 41.0305L28.6192 40.5294C29.0587 40.9063 29.5076 41.2062 29.9659 41.4289C30.4241 41.6431 30.9385 41.7716 31.509 41.8144V38.1649C30.4522 37.9507 29.69 37.6594 29.2224 37.2911C28.7641 36.9141 28.535 36.4044 28.535 35.7618V35.7361C28.535 35.4192 28.6051 35.1236 28.7454 34.8495C28.8951 34.5668 29.1008 34.3226 29.3627 34.117C29.6245 33.9114 29.9331 33.7486 30.2885 33.6287C30.6532 33.5002 31.0507 33.4316 31.4809 33.4231V32.6777H32.1542V33.4488C32.6967 33.4916 33.1783 33.603 33.5991 33.7829C34.02 33.9542 34.4408 34.1941 34.8617 34.5025L34.3987 35.0037C34.034 34.7038 33.6646 34.4768 33.2905 34.3226C32.9258 34.1684 32.5377 34.0699 32.1262 34.027V37.638C33.1923 37.8436 33.9639 38.1392 34.4408 38.5247C34.9178 38.9016 35.1563 39.4028 35.1563 40.0282V40.0539C35.1563 40.388 35.0814 40.6964 34.9318 40.9791C34.7915 41.2618 34.5858 41.5103 34.3146 41.7245C34.0527 41.9301 33.7347 42.0928 33.3607 42.2128C32.9959 42.3327 32.5938 42.4013 32.1542 42.4184V43.6777H31.4809V42.4055Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter6_f_3003_69649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1262 41.8401C32.4722 41.8316 32.7855 41.7844 33.0661 41.6988C33.356 41.6045 33.6038 41.4803 33.8096 41.3261C34.0153 41.1719 34.1696 40.992 34.2725 40.7864C34.3847 40.5722 34.4408 40.3452 34.4408 40.1053V40.0796C34.4408 39.8654 34.4081 39.6684 34.3426 39.4885C34.2772 39.3086 34.1556 39.1458 33.9779 39.0002C33.8002 38.8545 33.5617 38.726 33.2625 38.6147C32.9632 38.4947 32.5844 38.3876 32.1262 38.2934V41.8401ZM31.509 34.0013C30.8263 34.0185 30.2792 34.1898 29.8677 34.5154C29.4562 34.8323 29.2504 35.2221 29.2504 35.6847V35.7104C29.2504 35.9161 29.2832 36.1088 29.3486 36.2887C29.4141 36.4601 29.531 36.6228 29.6993 36.777C29.8677 36.9227 30.0968 37.0555 30.3867 37.1754C30.6766 37.2953 31.0507 37.4067 31.509 37.5095V34.0013ZM31.4809 42.4055C30.8356 42.3541 30.2464 42.2171 29.7134 41.9943C29.1803 41.763 28.6613 41.4418 28.1562 41.0305L28.6192 40.5294C29.0587 40.9063 29.5076 41.2062 29.9659 41.4289C30.4241 41.6431 30.9385 41.7716 31.509 41.8144V38.1649C30.4522 37.9507 29.69 37.6594 29.2224 37.2911C28.7641 36.9141 28.535 36.4044 28.535 35.7618V35.7361C28.535 35.4192 28.6051 35.1236 28.7454 34.8495C28.8951 34.5668 29.1008 34.3226 29.3627 34.117C29.6245 33.9114 29.9331 33.7486 30.2885 33.6287C30.6532 33.5002 31.0507 33.4316 31.4809 33.4231V32.6777H32.1542V33.4488C32.6967 33.4916 33.1783 33.603 33.5991 33.7829C34.02 33.9542 34.4408 34.1941 34.8617 34.5025L34.3987 35.0037C34.034 34.7038 33.6646 34.4768 33.2905 34.3226C32.9258 34.1684 32.5377 34.0699 32.1262 34.027V37.638C33.1923 37.8436 33.9639 38.1392 34.4408 38.5247C34.9178 38.9016 35.1563 39.4028 35.1563 40.0282V40.0539C35.1563 40.388 35.0814 40.6964 34.9318 40.9791C34.7915 41.2618 34.5858 41.5103 34.3146 41.7245C34.0527 41.9301 33.7347 42.0928 33.3607 42.2128C32.9959 42.3327 32.5938 42.4013 32.1542 42.4184V43.6777H31.4809V42.4055Z",
    fill: "#FBF2C3"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_3003_69649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1562 49.6777H46.1562V58.1777C46.1562 61.7676 43.2461 64.6777 39.6562 64.6777V64.6777C36.0664 64.6777 33.1562 61.7676 33.1562 58.1777V49.6777Z",
    fill: "url(#paint2_linear_3003_69649)",
    shapeRendering: "crispEdges"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_3003_69649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.1262 41.8401C48.4722 41.8316 48.7855 41.7844 49.0661 41.6988C49.356 41.6045 49.6038 41.4803 49.8096 41.3261C50.0153 41.1719 50.1696 40.992 50.2725 40.7864C50.3847 40.5722 50.4408 40.3452 50.4408 40.1053V40.0796C50.4408 39.8654 50.4081 39.6684 50.3426 39.4885C50.2772 39.3086 50.1556 39.1458 49.9779 39.0002C49.8002 38.8545 49.5617 38.726 49.2625 38.6147C48.9632 38.4947 48.5844 38.3876 48.1262 38.2934V41.8401ZM47.509 34.0013C46.8263 34.0185 46.2792 34.1898 45.8677 34.5154C45.4562 34.8323 45.2504 35.2221 45.2504 35.6847V35.7104C45.2504 35.9161 45.2832 36.1088 45.3486 36.2887C45.4141 36.4601 45.531 36.6228 45.6993 36.777C45.8677 36.9227 46.0968 37.0555 46.3867 37.1754C46.6766 37.2953 47.0507 37.4067 47.509 37.5095V34.0013ZM47.4809 42.4055C46.8356 42.3541 46.2464 42.2171 45.7134 41.9943C45.1803 41.763 44.6613 41.4418 44.1562 41.0305L44.6192 40.5294C45.0587 40.9063 45.5076 41.2062 45.9659 41.4289C46.4241 41.6431 46.9385 41.7716 47.509 41.8144V38.1649C46.4522 37.9507 45.69 37.6594 45.2224 37.2911C44.7641 36.9141 44.535 36.4044 44.535 35.7618V35.7361C44.535 35.4192 44.6051 35.1236 44.7454 34.8495C44.8951 34.5668 45.1008 34.3226 45.3627 34.117C45.6245 33.9114 45.9331 33.7486 46.2885 33.6287C46.6532 33.5002 47.0507 33.4316 47.4809 33.4231V32.6777H48.1542V33.4488C48.6967 33.4916 49.1783 33.603 49.5991 33.7829C50.02 33.9542 50.4408 34.1941 50.8617 34.5025L50.3987 35.0037C50.034 34.7038 49.6646 34.4768 49.2905 34.3226C48.9258 34.1684 48.5377 34.0699 48.1262 34.027V37.638C49.1923 37.8436 49.9639 38.1392 50.4408 38.5247C50.9178 38.9016 51.1563 39.4028 51.1563 40.0282V40.0539C51.1563 40.388 51.0814 40.6964 50.9318 40.9791C50.7915 41.2618 50.5858 41.5103 50.3146 41.7245C50.0527 41.9301 49.7347 42.0928 49.3607 42.2128C48.9959 42.3327 48.5938 42.4013 48.1542 42.4184V43.6777H47.4809V42.4055Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.1262 41.8401C48.4722 41.8316 48.7855 41.7844 49.0661 41.6988C49.356 41.6045 49.6038 41.4803 49.8096 41.3261C50.0153 41.1719 50.1696 40.992 50.2725 40.7864C50.3847 40.5722 50.4408 40.3452 50.4408 40.1053V40.0796C50.4408 39.8654 50.4081 39.6684 50.3426 39.4885C50.2772 39.3086 50.1556 39.1458 49.9779 39.0002C49.8002 38.8545 49.5617 38.726 49.2625 38.6147C48.9632 38.4947 48.5844 38.3876 48.1262 38.2934V41.8401ZM47.509 34.0013C46.8263 34.0185 46.2792 34.1898 45.8677 34.5154C45.4562 34.8323 45.2504 35.2221 45.2504 35.6847V35.7104C45.2504 35.9161 45.2832 36.1088 45.3486 36.2887C45.4141 36.4601 45.531 36.6228 45.6993 36.777C45.8677 36.9227 46.0968 37.0555 46.3867 37.1754C46.6766 37.2953 47.0507 37.4067 47.509 37.5095V34.0013ZM47.4809 42.4055C46.8356 42.3541 46.2464 42.2171 45.7134 41.9943C45.1803 41.763 44.6613 41.4418 44.1562 41.0305L44.6192 40.5294C45.0587 40.9063 45.5076 41.2062 45.9659 41.4289C46.4241 41.6431 46.9385 41.7716 47.509 41.8144V38.1649C46.4522 37.9507 45.69 37.6594 45.2224 37.2911C44.7641 36.9141 44.535 36.4044 44.535 35.7618V35.7361C44.535 35.4192 44.6051 35.1236 44.7454 34.8495C44.8951 34.5668 45.1008 34.3226 45.3627 34.117C45.6245 33.9114 45.9331 33.7486 46.2885 33.6287C46.6532 33.5002 47.0507 33.4316 47.4809 33.4231V32.6777H48.1542V33.4488C48.6967 33.4916 49.1783 33.603 49.5991 33.7829C50.02 33.9542 50.4408 34.1941 50.8617 34.5025L50.3987 35.0037C50.034 34.7038 49.6646 34.4768 49.2905 34.3226C48.9258 34.1684 48.5377 34.0699 48.1262 34.027V37.638C49.1923 37.8436 49.9639 38.1392 50.4408 38.5247C50.9178 38.9016 51.1563 39.4028 51.1563 40.0282V40.0539C51.1563 40.388 51.0814 40.6964 50.9318 40.9791C50.7915 41.2618 50.5858 41.5103 50.3146 41.7245C50.0527 41.9301 49.7347 42.0928 49.3607 42.2128C48.9959 42.3327 48.5938 42.4013 48.1542 42.4184V43.6777H47.4809V42.4055Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter9_f_3003_69649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.1262 41.8401C48.4722 41.8316 48.7855 41.7844 49.0661 41.6988C49.356 41.6045 49.6038 41.4803 49.8096 41.3261C50.0153 41.1719 50.1696 40.992 50.2725 40.7864C50.3847 40.5722 50.4408 40.3452 50.4408 40.1053V40.0796C50.4408 39.8654 50.4081 39.6684 50.3426 39.4885C50.2772 39.3086 50.1556 39.1458 49.9779 39.0002C49.8002 38.8545 49.5617 38.726 49.2625 38.6147C48.9632 38.4947 48.5844 38.3876 48.1262 38.2934V41.8401ZM47.509 34.0013C46.8263 34.0185 46.2792 34.1898 45.8677 34.5154C45.4562 34.8323 45.2504 35.2221 45.2504 35.6847V35.7104C45.2504 35.9161 45.2832 36.1088 45.3486 36.2887C45.4141 36.4601 45.531 36.6228 45.6993 36.777C45.8677 36.9227 46.0968 37.0555 46.3867 37.1754C46.6766 37.2953 47.0507 37.4067 47.509 37.5095V34.0013ZM47.4809 42.4055C46.8356 42.3541 46.2464 42.2171 45.7134 41.9943C45.1803 41.763 44.6613 41.4418 44.1562 41.0305L44.6192 40.5294C45.0587 40.9063 45.5076 41.2062 45.9659 41.4289C46.4241 41.6431 46.9385 41.7716 47.509 41.8144V38.1649C46.4522 37.9507 45.69 37.6594 45.2224 37.2911C44.7641 36.9141 44.535 36.4044 44.535 35.7618V35.7361C44.535 35.4192 44.6051 35.1236 44.7454 34.8495C44.8951 34.5668 45.1008 34.3226 45.3627 34.117C45.6245 33.9114 45.9331 33.7486 46.2885 33.6287C46.6532 33.5002 47.0507 33.4316 47.4809 33.4231V32.6777H48.1542V33.4488C48.6967 33.4916 49.1783 33.603 49.5991 33.7829C50.02 33.9542 50.4408 34.1941 50.8617 34.5025L50.3987 35.0037C50.034 34.7038 49.6646 34.4768 49.2905 34.3226C48.9258 34.1684 48.5377 34.0699 48.1262 34.027V37.638C49.1923 37.8436 49.9639 38.1392 50.4408 38.5247C50.9178 38.9016 51.1563 39.4028 51.1563 40.0282V40.0539C51.1563 40.388 51.0814 40.6964 50.9318 40.9791C50.7915 41.2618 50.5858 41.5103 50.3146 41.7245C50.0527 41.9301 49.7347 42.0928 49.3607 42.2128C48.9959 42.3327 48.5938 42.4013 48.1542 42.4184V43.6777H47.4809V42.4055Z",
    fill: "#FBF2C3"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_3003_69649)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.6562,
    cy: 59.1777,
    rx: 3.5,
    ry: 4.5,
    fill: "#FBF2C3"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_3003_69649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1262 60.8401C40.4722 60.8316 40.7855 60.7844 41.0661 60.6988C41.356 60.6045 41.6038 60.4803 41.8096 60.3261C42.0153 60.1719 42.1696 59.992 42.2725 59.7864C42.3847 59.5722 42.4408 59.3452 42.4408 59.1053V59.0796C42.4408 58.8654 42.4081 58.6684 42.3426 58.4885C42.2772 58.3086 42.1556 58.1458 41.9779 58.0002C41.8002 57.8545 41.5617 57.726 41.2625 57.6147C40.9632 57.4947 40.5844 57.3876 40.1262 57.2934V60.8401ZM39.509 53.0013C38.8263 53.0185 38.2792 53.1898 37.8677 53.5154C37.4562 53.8323 37.2504 54.2221 37.2504 54.6847V54.7104C37.2504 54.9161 37.2832 55.1088 37.3486 55.2887C37.4141 55.4601 37.531 55.6228 37.6993 55.777C37.8677 55.9227 38.0968 56.0555 38.3867 56.1754C38.6766 56.2953 39.0507 56.4067 39.509 56.5095V53.0013ZM39.4809 61.4055C38.8356 61.3541 38.2464 61.2171 37.7134 60.9943C37.1803 60.763 36.6613 60.4418 36.1562 60.0305L36.6192 59.5294C37.0587 59.9063 37.5076 60.2062 37.9659 60.4289C38.4241 60.6431 38.9385 60.7716 39.509 60.8144V57.1649C38.4522 56.9507 37.69 56.6594 37.2224 56.2911C36.7641 55.9141 36.535 55.4044 36.535 54.7618V54.7361C36.535 54.4192 36.6051 54.1236 36.7454 53.8495C36.8951 53.5668 37.1008 53.3226 37.3627 53.117C37.6245 52.9114 37.9331 52.7486 38.2885 52.6287C38.6532 52.5002 39.0507 52.4316 39.4809 52.4231V51.6777H40.1542V52.4488C40.6967 52.4916 41.1783 52.603 41.5991 52.7829C42.02 52.9542 42.4408 53.1941 42.8617 53.5025L42.3987 54.0037C42.034 53.7038 41.6646 53.4768 41.2905 53.3226C40.9258 53.1684 40.5377 53.0699 40.1262 53.027V56.638C41.1923 56.8436 41.9639 57.1392 42.4408 57.5247C42.9178 57.9016 43.1563 58.4028 43.1563 59.0282V59.0539C43.1563 59.388 43.0814 59.6964 42.9318 59.9791C42.7915 60.2618 42.5858 60.5103 42.3146 60.7245C42.0527 60.9301 41.7347 61.0928 41.3607 61.2128C40.9959 61.3327 40.5938 61.4013 40.1542 61.4184V62.6777H39.4809V61.4055Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.1262 60.8401C40.4722 60.8316 40.7855 60.7844 41.0661 60.6988C41.356 60.6045 41.6038 60.4803 41.8096 60.3261C42.0153 60.1719 42.1696 59.992 42.2725 59.7864C42.3847 59.5722 42.4408 59.3452 42.4408 59.1053V59.0796C42.4408 58.8654 42.4081 58.6684 42.3426 58.4885C42.2772 58.3086 42.1556 58.1458 41.9779 58.0002C41.8002 57.8545 41.5617 57.726 41.2625 57.6147C40.9632 57.4947 40.5844 57.3876 40.1262 57.2934V60.8401ZM39.509 53.0013C38.8263 53.0185 38.2792 53.1898 37.8677 53.5154C37.4562 53.8323 37.2504 54.2221 37.2504 54.6847V54.7104C37.2504 54.9161 37.2832 55.1088 37.3486 55.2887C37.4141 55.4601 37.531 55.6228 37.6993 55.777C37.8677 55.9227 38.0968 56.0555 38.3867 56.1754C38.6766 56.2953 39.0507 56.4067 39.509 56.5095V53.0013ZM39.4809 61.4055C38.8356 61.3541 38.2464 61.2171 37.7134 60.9943C37.1803 60.763 36.6613 60.4418 36.1562 60.0305L36.6192 59.5294C37.0587 59.9063 37.5076 60.2062 37.9659 60.4289C38.4241 60.6431 38.9385 60.7716 39.509 60.8144V57.1649C38.4522 56.9507 37.69 56.6594 37.2224 56.2911C36.7641 55.9141 36.535 55.4044 36.535 54.7618V54.7361C36.535 54.4192 36.6051 54.1236 36.7454 53.8495C36.8951 53.5668 37.1008 53.3226 37.3627 53.117C37.6245 52.9114 37.9331 52.7486 38.2885 52.6287C38.6532 52.5002 39.0507 52.4316 39.4809 52.4231V51.6777H40.1542V52.4488C40.6967 52.4916 41.1783 52.603 41.5991 52.7829C42.02 52.9542 42.4408 53.1941 42.8617 53.5025L42.3987 54.0037C42.034 53.7038 41.6646 53.4768 41.2905 53.3226C40.9258 53.1684 40.5377 53.0699 40.1262 53.027V56.638C41.1923 56.8436 41.9639 57.1392 42.4408 57.5247C42.9178 57.9016 43.1563 58.4028 43.1563 59.0282V59.0539C43.1563 59.388 43.0814 59.6964 42.9318 59.9791C42.7915 60.2618 42.5858 60.5103 42.3146 60.7245C42.0527 60.9301 41.7347 61.0928 41.3607 61.2128C40.9959 61.3327 40.5938 61.4013 40.1542 61.4184V62.6777H39.4809V61.4055Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter12_f_3003_69649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1262 60.8401C40.4722 60.8316 40.7855 60.7844 41.0661 60.6988C41.356 60.6045 41.6038 60.4803 41.8096 60.3261C42.0153 60.1719 42.1696 59.992 42.2725 59.7864C42.3847 59.5722 42.4408 59.3452 42.4408 59.1053V59.0796C42.4408 58.8654 42.4081 58.6684 42.3426 58.4885C42.2772 58.3086 42.1556 58.1458 41.9779 58.0002C41.8002 57.8545 41.5617 57.726 41.2625 57.6147C40.9632 57.4947 40.5844 57.3876 40.1262 57.2934V60.8401ZM39.509 53.0013C38.8263 53.0185 38.2792 53.1898 37.8677 53.5154C37.4562 53.8323 37.2504 54.2221 37.2504 54.6847V54.7104C37.2504 54.9161 37.2832 55.1088 37.3486 55.2887C37.4141 55.4601 37.531 55.6228 37.6993 55.777C37.8677 55.9227 38.0968 56.0555 38.3867 56.1754C38.6766 56.2953 39.0507 56.4067 39.509 56.5095V53.0013ZM39.4809 61.4055C38.8356 61.3541 38.2464 61.2171 37.7134 60.9943C37.1803 60.763 36.6613 60.4418 36.1562 60.0305L36.6192 59.5294C37.0587 59.9063 37.5076 60.2062 37.9659 60.4289C38.4241 60.6431 38.9385 60.7716 39.509 60.8144V57.1649C38.4522 56.9507 37.69 56.6594 37.2224 56.2911C36.7641 55.9141 36.535 55.4044 36.535 54.7618V54.7361C36.535 54.4192 36.6051 54.1236 36.7454 53.8495C36.8951 53.5668 37.1008 53.3226 37.3627 53.117C37.6245 52.9114 37.9331 52.7486 38.2885 52.6287C38.6532 52.5002 39.0507 52.4316 39.4809 52.4231V51.6777H40.1542V52.4488C40.6967 52.4916 41.1783 52.603 41.5991 52.7829C42.02 52.9542 42.4408 53.1941 42.8617 53.5025L42.3987 54.0037C42.034 53.7038 41.6646 53.4768 41.2905 53.3226C40.9258 53.1684 40.5377 53.0699 40.1262 53.027V56.638C41.1923 56.8436 41.9639 57.1392 42.4408 57.5247C42.9178 57.9016 43.1563 58.4028 43.1563 59.0282V59.0539C43.1563 59.388 43.0814 59.6964 42.9318 59.9791C42.7915 60.2618 42.5858 60.5103 42.3146 60.7245C42.0527 60.9301 41.7347 61.0928 41.3607 61.2128C40.9959 61.3327 40.5938 61.4013 40.1542 61.4184V62.6777H39.4809V61.4055Z",
    fill: "#FBF2C3"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter13_i_3003_69649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0643 26.9646C35.0643 27.5002 34.3733 27.0558 31.2741 27.4266C28.1749 27.7973 24.8322 30.1123 24.5115 29.6804C24.056 29.0668 28.2625 26.3967 31.2741 26.049C34.2858 25.7013 35.0643 26.4291 35.0643 26.9646Z",
    fill: "#262626"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_3003_69649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0643 26.9646C35.0643 27.5002 34.3733 27.0558 31.2741 27.4266C28.1749 27.7973 24.8322 30.1123 24.5115 29.6804C24.056 29.0668 28.2625 26.3967 31.2741 26.049C34.2858 25.7013 35.0643 26.4291 35.0643 26.9646Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3705 26.7572C34.4447 26.8018 34.4908 26.8432 34.5182 26.8747C34.564 26.9274 34.5643 26.9584 34.5643 26.9646C34.5643 26.9676 34.5642 26.9689 34.5642 26.9689C34.5641 26.9689 34.5642 26.9674 34.5645 26.9646C34.5658 26.9513 34.5728 26.9087 34.6048 26.8576C34.6566 26.7749 34.7259 26.7445 34.7434 26.7384C34.7442 26.7382 34.7446 26.738 34.7446 26.738C34.7445 26.7378 34.7195 26.7446 34.6474 26.7496C34.5783 26.7544 34.4895 26.7564 34.3705 26.7572ZM34.3705 26.7572C34.3572 26.7573 34.3435 26.7574 34.3294 26.7574C34.2779 26.7576 34.2228 26.7576 34.1641 26.7577C33.5849 26.7579 32.6504 26.7584 31.2147 26.9301C29.5809 27.1256 27.9079 27.8278 26.6449 28.3989C26.4684 28.4787 26.3014 28.5552 26.1438 28.6275C26.356 28.4873 26.59 28.3431 26.8417 28.1985C28.1838 27.4275 29.9207 26.7085 31.3315 26.5457C32.8063 26.3754 33.6642 26.4787 34.1294 26.6461C34.2316 26.6829 34.3103 26.7211 34.3705 26.7572ZM24.9639 29.6453C24.9636 29.6454 24.9646 29.6426 24.9675 29.6366C24.9656 29.6421 24.9641 29.6452 24.9639 29.6453Z",
    stroke: "#FBF2C3"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter15_i_3003_69649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.174 26.9646C44.174 27.5002 44.8649 27.0558 47.9642 27.4266C51.0634 27.7973 54.4061 30.1123 54.7268 29.6804C55.1823 29.0668 50.9758 26.3967 47.9641 26.049C44.9525 25.7013 44.174 26.4291 44.174 26.9646Z",
    fill: "#262626"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_3003_69649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.174 26.9646C44.174 27.5002 44.8649 27.0558 47.9642 27.4266C51.0634 27.7973 54.4061 30.1123 54.7268 29.6804C55.1823 29.0668 50.9758 26.3967 47.9641 26.049C44.9525 25.7013 44.174 26.4291 44.174 26.9646Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8678 26.7572C44.7936 26.8018 44.7475 26.8432 44.7201 26.8747C44.6743 26.9274 44.674 26.9584 44.674 26.9646C44.674 26.9676 44.6741 26.9689 44.6741 26.9689C44.6741 26.9689 44.6741 26.9674 44.6738 26.9646C44.6724 26.9513 44.6654 26.9087 44.6335 26.8576C44.5816 26.7749 44.5124 26.7445 44.4949 26.7384C44.4941 26.7382 44.4937 26.738 44.4937 26.738C44.4938 26.7378 44.5187 26.7446 44.5909 26.7496C44.66 26.7544 44.7488 26.7564 44.8678 26.7572ZM44.8678 26.7572C44.8811 26.7573 44.8948 26.7574 44.9088 26.7574C44.9604 26.7576 45.0155 26.7576 45.0742 26.7577C45.6533 26.7579 46.5879 26.7584 48.0235 26.9301C49.6574 27.1256 51.3303 27.8278 52.5934 28.3989C52.7699 28.4787 52.9369 28.5552 53.0945 28.6275C52.8823 28.4873 52.6483 28.3431 52.3966 28.1985C51.0544 27.4275 49.3176 26.7085 47.9068 26.5457C46.432 26.3754 45.5741 26.4787 45.1089 26.6461C45.0067 26.6829 44.928 26.7211 44.8678 26.7572ZM54.2744 29.6453C54.2747 29.6454 54.2737 29.6426 54.2708 29.6366C54.2727 29.6421 54.2742 29.6452 54.2744 29.6453Z",
    stroke: "#FBF2C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3003_69649",
    x: 15.5117,
    y: 5.22266,
    width: 48,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_3003_69649"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3003_69649",
    x: 3.51172,
    y: 18.2227,
    width: 43,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_3003_69649"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3003_69649",
    x: 32.5117,
    y: 18.2227,
    width: 43,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_3003_69649"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_3003_69649",
    x: 27.3672,
    y: 47.5176,
    width: 24.6475,
    height: 8.70508,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3003_69649"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3003_69649",
    x: 20.3672,
    y: 40.5176,
    width: 38.6475,
    height: 22.7051,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_3003_69649"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_3003_69649",
    x: 27.792,
    y: 32.4277,
    width: 7.61426,
    height: 11.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14902 0 0 0 0 0.14902 0 0 0 0 0.14902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3003_69649"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_3003_69649",
    x: 21.1562,
    y: 25.6777,
    width: 21,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_3003_69649"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_3003_69649",
    x: 31.1562,
    y: 47.6777,
    width: 17,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3003_69649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3003_69649",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_3003_69649",
    x: 43.792,
    y: 32.4277,
    width: 7.61426,
    height: 11.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14902 0 0 0 0 0.14902 0 0 0 0 0.14902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3003_69649"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_3003_69649",
    x: 37.1562,
    y: 25.6777,
    width: 21,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_3003_69649"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_3003_69649",
    x: 29.1562,
    y: 47.6777,
    width: 21,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_3003_69649"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_3003_69649",
    x: 35.792,
    y: 51.4277,
    width: 7.61426,
    height: 11.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14902 0 0 0 0 0.14902 0 0 0 0 0.14902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3003_69649"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_3003_69649",
    x: 29.1562,
    y: 44.6777,
    width: 21,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_3003_69649"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_3003_69649",
    x: 24.4775,
    y: 25.959,
    width: 10.5869,
    height: 4.77539,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3003_69649"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_3003_69649",
    x: 20.4775,
    y: 21.959,
    width: 18.5869,
    height: 11.7754,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_3003_69649"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_3003_69649",
    x: 44.1738,
    y: 25.959,
    width: 10.5869,
    height: 4.77539,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3003_69649"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_3003_69649",
    x: 40.1738,
    y: 21.959,
    width: 18.5869,
    height: 11.7754,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_3003_69649"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3003_69649",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.5117 40.2227) rotate(89.6589) scale(23.4456)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.916667,
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3003_69649",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.5117 40.2227) rotate(89.6589) scale(23.4456)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.916667,
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3003_69649",
    x1: 39.6562,
    y1: 49.6777,
    x2: 39.6562,
    y2: 64.6777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEECB5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151042,
    stopColor: "#CEECB5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionTakeMyMoney);
export default __webpack_public_path__ + "static/media/reaction_take-my-money.7a9d39e29f10594b0bde239a39ec4b3f.svg";
export { ForwardRef as ReactComponent };